import { genericSort } from "../customSort/customSort";

export const bankDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    
    {
        Header: "Bank Name",
        accessor: "bankName",
        sortType:genericSort
    },
    {
        Header: "Alias Name",
        accessor: "aliasName",
        sortType:genericSort
    },
    {
        Header: "Branch Name",
        accessor: "branchName",
        sortType:genericSort
    },
    {
      Header: "Account Number",
      accessor: "accountNumber",
      sortType:genericSort
    },
   
    {
      Header: "IFSC Code",
      accessor: "ifscCode",
      sortType:genericSort
    },
    {
      Header: "Contact Person Name",
      accessor: "contactPerson",
   },
   {
    Header: "Payment Attached",
    accessor: "attachePayment",
   },
   {
    Header: "Primary",
    accessor: "isPrimary",
   },
    
    {
      Header: "Action",
      accessor: "action",
    },
    
  ];